"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _inline_svg = require("./inline_svg.utils");

var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));

var _excluded = ["fontsize", "themeColor"];

var NewHotelIcon = function NewHotelIcon(props) {
  var fontsize = props.fontsize,
      themeColor = props.themeColor,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  var theme = _react.default.useContext(_styledComponents.ThemeContext);

  var _parseStyles = (0, _inline_svg.parseStyles)({
    fontsize: fontsize,
    themeColor: themeColor
  }, theme),
      sizeStyles = _parseStyles.sizeStyles,
      colorStyles = _parseStyles.colorStyles;

  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    d: "M2.9131 7.57491L-3.24557e-07 7.57491L0 14.9999L13.2 14.9999L13.2 0.149907L2.9131 0.149908L2.9131  7.57491ZM11.7434 12.0484L11.7434 13.5241L10.2869 13.5241L10.2869 12.0484L11.7434 12.0484ZM8.78483 12.0484L8.78483 13.5241L7.32828 13.5241L7.32828 12.0484L8.78483 12.0484ZM5.87172  12.0484L5.87172 13.5241L4.41517 13.5241L4.41517 12.0484L5.87172 12.0484ZM2.9131 12.0484L2.9131 13.5241L1.45655 13.5241L1.45655 12.0484L2.9131 12.0484ZM11.7434 9.05068L11.7434 10.5265L10.2869 10.5265L10.2869 9.05068L11.7434 9.05068ZM8.78483 9.05068L8.78483 10.5265L7.32828 10.5265L7.32827 9.05068L8.78483 9.05068ZM5.87172 9.05068L5.87172 10.5265L4.41517 10.5265L4.41517 9.05068L5.87172 9.05068ZM2.9131 9.05068L2.9131 10.5265L1.45655 10.5265L1.45655 9.05068L2.9131 9.05068ZM11.7434 1.62568L11.7434 7.57491L10.2869 7.57491L10.2869 6.09913L8.83035 6.09913L8.83035 7.57491L7.37379 7.57491L7.37379 6.09913L5.91724 6.09913L5.91724 7.57491L4.46069 7.57491L4.46069 1.62568L11.7434 1.62568ZM5.87172 3.10146L5.87172 4.57724L7.32827 4.57724L7.32827 3.10146L5.87172 3.10146ZM8.78483 3.10146L8.78483 4.57724L10.2414 4.57724L10.2414 3.10146L8.78483 3.10146Z",
    fill: "#75767A"
  }, colorStyles)));
};

NewHotelIcon.propTypes = _inline_svg2.default.propTypes;
NewHotelIcon.defaultProps = _inline_svg2.default.defaultProps;
var _default = NewHotelIcon;
exports.default = _default;